// import "@mantine/core/styles.layer.css";
// import "mantine-datatable/styles.layer.css";
// import "@mantine/notifications/styles.layer.css";

// import React from "react";
// import { createRoot } from "react-dom/client";
// import AppContainer from "./AppContainer";
// import * as Sentry from "@sentry/react";

// export const startProject = () => {
//   // const point: Point = { x: 1, y: 2 };
//   // logPoint(point);
//   //console.log("is js heavy");
// };
// //window.location.hostname === "megalithic.me"
// if (true) {
// }

// document.addEventListener("DOMContentLoaded", () => {
//   console.log("DOM fully loaded and parsed");
//   const container = document.getElementById("root");
//   console.log("found this container", container);
//   const root = createRoot(container);
//   root.render(<AppContainer />);
// });

import "@mantine/core/styles.layer.css";
import "mantine-datatable/styles.layer.css";
import "@mantine/notifications/styles.layer.css";

import React, { useLayoutEffect } from "react";
import { createRoot } from "react-dom/client";
import AppContainer from "./AppContainer";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://741915706de8ffdd4a2ca6122446d4a4@o127869.ingest.us.sentry.io/4510086831341568",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: false,
});

export const startProject = () => {};

// Tool pages hide their server-rendered fallback until React has mounted
// (layouts/_tool_shell). This runs in the same commit that paints the real layout,
// after ServerRenderedBlock has moved the SSR sections into it.
const RevealPage: React.FC = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.remove("rz-react-pending");
  }, []);
  return null;
};

if (true) {
}

// Replace the old listener with this:
const initApp = () => {
  console.log("Initializing app");
  const container = document.getElementById("root");
  // console.log("found this container", container);
  if (container) {
    const root = createRoot(container);
    root.render(
      <>
        <AppContainer />
        <RevealPage />
      </>
    );
  } else {
    console.error("Root container not found");
  }
};

if (document.readyState === "loading") {
  // DOM not ready yet, wait for the event
  document.addEventListener("DOMContentLoaded", initApp);
} else {
  // DOM already ready (or interactive/complete), run immediately
  initApp();
}
